import React from 'react';

import { LinksToCheckProvider } from './LinksToCheckContext';
import LinksToCheckTabs from './LinksToCheckTabs';
import LinkCard from './LinkCard';
import LinkCardUpNext from './LinkCardUpNext';
import KeysOverlay from './KeysOverlay';
import TodayPopover from './TodayPopover';
import UndoToast from './UndoToast';

import './LinksToCheck.scss';

/** The Links to Check page: one link at a time, by the question it asks, with the next ones already loaded. */
const LinksToCheck = () => (
  <LinksToCheckProvider>
    <div className='links-to-check-container'>
      <main className='links-to-check-inner'>
        <header className='links-to-check-header'>
          <div>
            <div className='crumb'>Matchers</div>
            <h1>Links to Check</h1>
            <p>Links we couldn’t settle on our own. Each one needs one answer from you.</p>
          </div>
          <div className='header-tools'>
            <TodayPopover />
            <KeysOverlay />
          </div>
        </header>
        <LinksToCheckTabs />
        <LinkCard />
        <LinkCardUpNext />
      </main>
      <UndoToast />
    </div>
  </LinksToCheckProvider>
);

export default LinksToCheck;
